export default "__VITE_ASSET__BU2BKrIQ__"